import { Card } from '@mui/material';
import ConfigurationTheme from '../Theme_Configuration/ConfigurationTheme';

function PermitTheme() {
  return ( 
    <Card sx={{mb:{xs:8, sm: "auto"}}}>
      <ConfigurationTheme />
    </Card>    
  );
}

export default PermitTheme;
